import { render, staticRenderFns } from "./AXPSettings.vue?vue&type=template&id=4b87ffab"
import script from "./AXPSettings.vue?vue&type=script&lang=js"
export * from "./AXPSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports